import { Col, Row } from 'antd'
import moment from 'moment/moment';
import React from 'react'

const UploadedLicense = ({storeObject}) => {
    return (
        <Row>
            <Col className="gutter-row" xs={24} lg={24}>
                <div className="d-flex">
                    <p className="font-weight-bolder font-size-lg mb-3 h5">
                        Uploaded License
                    </p>
                </div>
                {storeObject?.licenseDetails?.map((license, index) => {
                    return (
                        <div className="my-7 repeat_div">
                            <div className="row m-0">
                                <div className="col-sm-2">
                                    <label className="font-weight-bolder font-size-sm">
                                        Category
                                    </label>
                                    <input
                                        placeholder="Enter here"
                                        className="form-control text-capitalize"
                                        value={license?.name?.en}
                                        disabled
                                    />
                                </div>

                                <div className="col-sm-2">
                                    <label className="font-weight-bolder font-size-sm">
                                        Sub Category
                                    </label>
                                    <input
                                        placeholder="Enter here"
                                        className="form-control text-capitalize"
                                        value={license?.supplierName}
                                        disabled
                                    />
                                </div>

                                <div className="col-sm-3">
                                    <label className="font-weight-bolder font-size-sm">
                                        {license?.licenseId === "licenses/316087432"
                                            ? "Seed certification number"
                                            : "License Number"}
                                    </label>
                                    <input
                                        placeholder="Enter here"
                                        className="form-control"
                                        value={license?.licenseNumber}
                                        disabled
                                    />
                                </div>

                                <div className="col-sm-2">
                                    <label className="font-weight-bolder font-size-sm">
                                        Expiry Date
                                    </label>
                                    <input
                                        placeholder="Enter here"
                                        className="form-control"
                                        value={
                                            license?.expiryDate
                                                ? moment(license?.expiryDate).format(
                                                    "YYYY-MM-DD"
                                                )
                                                    ? moment(license?.expiryDate).format(
                                                        "YYYY-MM-DD"
                                                    )
                                                    : ""
                                                : ""
                                        }
                                        disabled
                                    />
                                </div>

                                <div className="col-sm-1 text-center">
                                    <label className="font-weight-bolder font-size-sm">
                                        Status
                                    </label>
                                    <div>
                                        <span
                                            className={
                                                license?.status === "APPROVED"
                                                    ? "bg-primary p-1 px-2 text-white rounded font-size-lg d-inline-block mb-2"
                                                    : license?.status === "PENDING"
                                                        ? "bg-warning p-1 px-2 text-white rounded font-size-lg d-inline-block mb-2"
                                                        : license?.status === "REJECTED"
                                                            ? "bg-gray-800 p-1 px-2 text-white rounded font-size-lg d-inline-block mb-2"
                                                            : "bg-danger p-1 px-2 text-white rounded font-size-lg d-inline-block mb-2"
                                            }
                                        >
                                            {license?.status}
                                        </span>
                                    </div>
                                </div>

                                <div className="col-sm-2 text-center">
                                    <label className="font-weight-bolder font-size-sm">
                                        File
                                    </label>
                                    <div className="imgPreview mt-0 mx-auto">
                                        <a
                                            href={license?.file?.fileKey}
                                            className="document_file"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="align-items-center d-flex fa-file-download fas h-75px icon-3x justify-content-center m-2 text-muted"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <span className="p-3 text-muted mt-5">
                                If you need any changes or have any queries, contact
                                admin at info@apnikheti.com
                            </span>
                        </div>
                    );
                })}
            </Col>
        </Row>
    )
}

export default UploadedLicense